import { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Popover, Select, Form, Input, Button, Tooltip } from 'antd';

import styles from "./space.module.css";

import { ReactComponent as AddIcon } from "./icons/add.svg";
import { Dialog } from "../../widgets/dialog";
import { useSpaceStore } from "../../stores/space";

import { PoweroffOutlined, ShareAltOutlined } from '@ant-design/icons';


import { ReactComponent as WorldIcon } from './icons/world.svg';
import { ReactComponent as OfficeIcon } from './icons/office.svg';
import { ReactComponent as ArrowIcon } from './icons/arrow-right.svg';
import { ReactComponent as ShareIcon } from './icons/share.svg';
import { ReactComponent as SettingsIcon } from './icons/settings.svg';
import { useUserStore } from "../../stores/user";
import { InfiniteCanvas } from "../../widgets/infinitecanvas";
import { Share } from "../../widgets/share";

const ROOM_TYPES = [
  {
    key: "personal",
    value: "personal",
    text: "Personal Room",
  },
  {
    key: "conference",
    value: "conference",
    text: "Conference Room",
  },
  {
    key: "workspace",
    value: "workspace",
    text: "Workspace",
  },
  {
    key: "auditorium",
    value: "auditorium",
    text: "Auditorium",
  },
  {
    key: "watercooler",
    value: "watercooler",
    text: "Water Cooler",
  },
];

export function Space() {
  const { id } = useParams();
  const { open, code } = useSpaceStore(state => state);
  const { logout } = useUserStore(state => state);
  const space = useSpaceStore((state) => state);
  const navigate = useNavigate();
  const [showShare, setShowShare] = useState(false);

  const rooms = useMemo(() => {
    if (!space) return [];
    const roomSize = space.size || 0;
    const matrix = [];
    for(let i = 0; i < roomSize; i++) {
      const row = [];
      for(let j = 0; j < roomSize; j++) {
        if(space.rooms && space.rooms.find(room => room.pos[0] === i && room.pos[1] === j)) {
          row.push(space.rooms.find(room => room.pos[0] === i && room.pos[1] === j));
        }
        else{
          row.push(null);
        }
      }
      matrix.push(row);
    }
    return matrix;
  }, [space, space?.rooms]);

  useEffect(() => {
    open(id);
  }, []);
  
  return (space ? <div className={styles.space}>
      <div className={`toolbar`}>
        <h1>{space.name} (#{code})</h1>
        <span style={{flex: "1 1 100%"}} />
        <Tooltip title="Share" placement="left">
          <button onClick={() => {
            setShowShare(true);
          }}><ShareAltOutlined /></button>
        </Tooltip>
        <Tooltip title="Log out" placement="left">
          <button onClick={() => {
            logout();
            window.location.href = "/auth";
          }}><PoweroffOutlined /></button>
        </Tooltip>
      </div>
      
        <InfiniteCanvas showCoords={false}>
          <div className={styles.rooms}>
          {rooms.map((row, rowIndex) => {
            return (
              <div key={`${rowIndex}`} className={styles.roomrow}>
                {row.map((room, roomIndex) => {
                  return <Room room={room} i={rowIndex} j={roomIndex} spaceId={id} />;
                })}
              </div>
            );
          })}
          </div>
        </InfiniteCanvas>
        
        {showShare && <Share onCancel={() => {
          setShowShare(false);
        }} />}
        <div className={styles.roombgloader} />
    </div> : 'Loading...'
  );
}

export function Room(props) {
  const navigate = useNavigate();
  const { id: userId } = useUserStore();
  const { room, i, j, spaceId } = props;
  const { createRoom } = useSpaceStore(state => state);
  const [showCreate, setShowCreate] = useState(false);
  const [newRoomName, setNewRoomName] = useState('');
  const [newRoomType, setNewRoomType] = useState('personal');
  return (
    <div className={`${styles.room} ${styles[room && room.type]} ${room ? styles.active : ""} ${room && room.locked && room.created.by !== userId ? styles.locked : ''}`}
    onClick={e => {
      room && navigate(`/room/${room.id}`);
    }}>
      <Popover
        trigger="click"
        visible={showCreate}
        onVisibleChange={visible => {
          setShowCreate(visible);
        }}
        content={<div className={styles.createroom} onMouseDown={e => {
          e.stopPropagation();
        }}>
          <Form layout="vertical" onFinish={async values => {
            await createRoom({
              name: newRoomName,
              type: newRoomType || "personal",
              spaceId,
              pos: [i, j]
            });
            setShowCreate(false);
          }}>
            <Form.Item label="Name" name="name">
              <Input value={newRoomName} onChange={e => {
                setNewRoomName(e.target.value);
              }} />
            </Form.Item>
            <Form.Item label="Type" name="type">
              <Select value={setNewRoomType} defaultValue={"personal"} onSelect={(value) => {
                setNewRoomType(value);
              }}>
                {ROOM_TYPES.map(type => <Select.Option key={type.key} value={type.value}>{type.text}</Select.Option>)}
              </Select>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={!newRoomName || !newRoomName.trim()}>
                Create
              </Button>
            </Form.Item>
          </Form>
        </div>}
      >
        <button className={styles.add}>
            <AddIcon />
          </button>
      </Popover>
      {room && <div className={styles.name}><span>{room.name}</span></div>}
    </div>
  );
}
